import React, { useState, useEffect } from 'react';
import { defineMessages, injectIntl } from 'react-intl';
import { Link } from 'react-router';

const messages = defineMessages({
  THANK_YOU: {
    id: 'AfterCallPage.THANK_YOU',
    defaultMessage: 'Vielen Dank für das Gespräch',
  },
  YOUR_TEAM: {
    id: 'AfterCallPage.YOUR_TEAM',
    defaultMessage: 'Ihr Team von {company}',
  },
  DISCONNECTED_HINT: {
    id: 'AfterCallPage.DISCONNECTED_HINT',
    defaultMessage: 'Falls das Gespräch unerwartet abgebrochen wurde, klicken Sie einfach auf „Seite aktualisieren“, um sich erneut zu verbinden. Ist Ihr Anliegen bereits geklärt, können Sie dieses Browserfenster nun einfach schließen.',
  },
  REFRESH_BUTTON: {
    id: 'AfterCallPage.REFRESH_BUTTON',
    defaultMessage: 'Seite aktualisieren',
  },
  BACK_LINK: {
    id: 'AfterCallPage.BACK_LINK',
    defaultMessage: 'Zurück zum Link',
  },
});

function AfterCallPage(props) {
  const { intl: { formatMessage }, params: { roomName, companyId } } = props;
  
  const [companyName, setCompanyName] = useState('...');
  const [userName, setUserName] = useState('');

  useEffect(() => {
    fetch('/api/room/', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ room: roomName, name: '' })
    })
    .then(r => r.json())
    .then(data => {
      if (data) {
        if (data.company_name) setCompanyName(data.company_name);
        if (data.user_name) setUserName(data.user_name);
      }
    })
    .catch(e => console.error(e));
  }, [roomName]);

  let pathName = `/v/${roomName}`;
  if (companyId) {
    pathName = `custom/${companyId}/v/${roomName}`;
  }

  return (
    <div className="after-call-page" style={{ 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center', 
      minHeight: '100vh', 
      backgroundColor: 'var(--bg, #1a1a1a)', 
      color: 'var(--text, #fff)',
      padding: '20px',
      fontFamily: '"Inter", "Outfit", sans-serif'
    }}>
      <div style={{ 
        maxWidth: '500px', 
        width: '100%', 
        background: 'rgba(255, 255, 255, 0.05)', 
        backdropFilter: 'blur(10px)', 
        border: '1px solid rgba(255, 255, 255, 0.1)', 
        borderRadius: '24px', 
        padding: '40px 30px', 
        textAlign: 'center',
        boxShadow: '0 20px 40px rgba(0, 0, 0, 0.4)'
      }}>
        
        <div style={{ marginBottom: '30px' }}>
          <i className="fa fa-check-circle" style={{ fontSize: '64px', color: '#10b981', marginBottom: '20px' }}></i>
          <h1 style={{ fontSize: '28px', fontWeight: '700', marginBottom: '10px', marginTop: 0 }}>
            {formatMessage(messages.THANK_YOU)}
          </h1>
          
          <p style={{ fontSize: '18px', color: 'rgba(255,255,255,0.9)', margin: '15px 0 5px 0' }}>
            {formatMessage(messages.YOUR_TEAM, { company: companyName })}
          </p>
          {userName && (
            <p style={{ fontSize: '16px', color: 'rgba(255,255,255,0.7)', margin: 0, fontWeight: '500' }}>
              {userName}
            </p>
          )}
        </div>

        <div style={{ 
          marginTop: '40px', 
          padding: '20px', 
          background: 'rgba(255,255,255,0.03)', 
          borderRadius: '16px',
          border: '1px solid rgba(255,255,255,0.05)'
        }}>
          <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)', lineHeight: '1.5', marginBottom: '20px' }}>
            {formatMessage(messages.DISCONNECTED_HINT)}
          </p>
          
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            <Link 
              to={pathName}
              style={{
                width: '100%',
                padding: '14px',
                background: 'var(--primary-color, #2563eb)',
                color: '#fff',
                border: 'none',
                borderRadius: '12px',
                fontSize: '15px',
                fontWeight: '600',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                textDecoration: 'none'
              }}
            >
              <i className="fa fa-refresh"></i>
              {formatMessage(messages.REFRESH_BUTTON)}
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}

export default injectIntl(AfterCallPage);
